import React from "react";
import { motion } from "framer-motion";
import CustomInput from "Common/CustomInput/CustomInput";
import CustomToggle from "Common/CustomToggle";
import MaskPhoneNumber from "Utils/MaskPhoneNumber";
import InfoIcon from "SVGS/InfoIcon";
import PropTypes from "prop-types";

const ContactInformation = ({
  ptModel,
  validationModel,
  handleChange,
  onPasteEmail,
  onToggleChange,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}

    >
      <div
        className="flex items-center justify-between cursor-pointer py-6"
      >
        <h3 className="text-lg font-medium text-gray-900">Contact Information</h3>

      </div>
      <div className="space-y-4 ">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <CustomInput
              onChange={handleChange}
              name="phoneNumber"
              value={MaskPhoneNumber(ptModel.phoneNumber, "generatemask")}
              label="Phone"
              placeholder="(123) 456-7896"

            />
            {validationModel.phoneNumberError}
          </div>
          <div className="col-span-12 md:col-span-6">
            <CustomInput
              onChange={onPasteEmail}
              name="email"
              value={ptModel.email}
              label="Email"
              placeholder="Email"
            />
            {validationModel.emailError}
          </div>
        </div>

        {/* Communication Preferences */}
        <div className="mt-6 pt-4 ">
          <h4 className="text-sm font-medium text-gray-900 mb-2">Communication Preferences</h4>
          <p className="text-sm text-gray-600 mb-4">
            Select how you would like to receive communications from us.
          </p>
          <div className="bg-gray-50 rounded-lg p-4 space-y-4">
            <div className="flex items-center justify-between py-2">
              <div className="flex items-center gap-2">
                <span className="text-gray-900 font-medium">Email</span>
                <InfoIcon
                  size={12}
                  className="inline text-gray-400"
                  data-tooltip-id="email-pref-tooltip"
                  data-tooltip-content="Receive appointment reminders, billing notices, and other updates via email"
                />
              </div>
              <CustomToggle
                onChange={() =>
                  onToggleChange({
                    ...ptModel,
                    communicationEmail: !ptModel.communicationEmail,
                    communicationText: false,
                    communicationMail: false,
                  })
                }
                name="communicationEmail"
                checked={ptModel.communicationEmail}
                label=""
              />
            </div>
            <div className="flex items-center justify-between py-2 border-t border-gray-200">
              <div className="flex items-center gap-2">
                <span className="text-gray-900 font-medium">Text Message</span>
                <InfoIcon
                  size={12}
                  className="inline text-gray-400"
                  data-tooltip-id="text-pref-tooltip"
                  data-tooltip-content="Receive appointment reminders and important notifications via text message"
                />
              </div>
              <CustomToggle
                onChange={() =>
                  onToggleChange({
                    ...ptModel,
                    communicationEmail: false,
                    communicationText: !ptModel.communicationText,
                    communicationMail: false,
                  })
                }
                name="communicationText"
                checked={ptModel.communicationText}
                label=""
              />
            </div>
            <div className="flex items-center justify-between py-2 border-t border-gray-200">
              <div className="flex items-center gap-2">
                <span className="text-gray-900 font-medium">Postal Mail</span>
                <InfoIcon
                  size={12}
                  className="inline text-gray-400"
                  data-tooltip-id="mail-pref-tooltip"
                  data-tooltip-content="Receive physical statements and correspondence via postal mail"
                />
              </div>
              <CustomToggle
                onChange={() =>
                  onToggleChange({
                    ...ptModel,
                    communicationEmail: false,
                    communicationText: false,
                    communicationMail: !ptModel.communicationMail,
                  })
                }
                name="communicationMail"
                checked={ptModel.communicationMail}
                label=""
              />
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-4"
          >
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
              <p className="text-sm text-blue-700">
                When you provide your contact information, you agree to hear from us. You can update your communication preferences.
                If no preference is selected, postal mail will be used by default.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

    </motion.div>
  );
};

ContactInformation.propTypes = {
  ptModel: PropTypes.object.isRequired,
  validationModel: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPasteEmail: PropTypes.func.isRequired,
  onToggleChange: PropTypes.func.isRequired,
};

export default ContactInformation;

